module.exports = __webpack_public_path__ + "img/xiazai02@3x.91340124.png";